import React from 'react';
import { RouteComponentProps } from '@reach/router';
import AppPromoCodeShared from './shared-component';
import Layout from '../../components/layout';
import SimpleFooter from '@components/simple-footer/simple-footer';

interface Props extends RouteComponentProps {
  appName?: string;
}

const AppPromoCode: React.FC<Props> = ({ appName = '' }) => {
  return (
    <Layout showFooter={false}>
      <AppPromoCodeShared appName={appName} />
      <SimpleFooter />
    </Layout>
  );
};

export default AppPromoCode; 